import vm from '@/main'
import { getDeviceId, getUrlQuery } from '@/utils'
import api from '@/api/api_list.js'
import RongIMLib from 'RongIMLib'

// const RYPARAMS = undefined

// let RYAPPKEY = 'p5tvi9dspnd14';
// let RYAPPKEY = 'y745wfm8yjmbv';

// if (process.env.NODE_ENV === 'production') {
//   RYAPPKEY = process.env.VUE_APP_RY_KEY || 'p5tvi9dspnd14';
// }

let currentUserInfo = {}

export class RYun {
  async initRy({ userInfo, liveId, on }) {
    this.RongIMClient = RongIMLib.RongIMClient
    // 记录用户信息
    currentUserInfo = userInfo
    this.liveId = liveId
    this.onMsgCallback =
      on ||
      function () { }

    let token = vm.$storage.get('rytoken') || ''
    // if (!token || token.indexOf('undefined') > -1) {
    //   token = await this.getRYToken()
    //   vm.$storage.set('rytoken', token)
    // }
    try{
      token = await this.getRYToken();
      vm.$storage.set('rytoken', token)
    }catch(e){
      console.log(e);
    }
    this.initClient(token)
  }
  // 获取融云token
  getRYToken() {
    const deviceId = getDeviceId()
    return new Promise((resolve, reject) => {
      api.get_rongyun_token({ deviceId })
        .then((res) => resolve(res.result.token))
        .catch((err) => reject(err))
    })
  }

  async getRYAppKey(){
    let {code, result} = await api.get_rongyun_appkey();
    if(code === 0 && result){
      this.RY_appkey = result.appKey;
      this.RY_navi = result.navigationAddress;
    }
  }

  async initClient(token) {
    try{
      await this.getRYAppKey();
    }catch(e){
      console.log(e);
    }
    

    // 调用初始函数 p5tvi9dspnd14
    // if (RYPARAMS) {
    //   this.RongIMClient.init(RYAPPKEY, null, RYPARAMS)
    // } else {
    //   this.RongIMClient.init(RYAPPKEY)
    // }
    try{
      this.RY_navi = this.RY_navi.replace(/(.*)\/$/, '$1');
    }catch(e){
        console.log('转换rongyun url时异常');
    }
    
    this.RongIMClient.init( this.RY_appkey , null, { navi: this.RY_navi });


    // 设置连接监听状态 （ status 标识当前连接状态 ）
    // 连接状态监听器
    this.RongIMClient.setConnectionStatusListener({
      onChanged: (status) => {
        console.log('onChanged', status)
        switch (status) {
          case RongIMLib.ConnectionStatus.CONNECTED:
            console.log('链接成功')
            break
          case RongIMLib.ConnectionStatus.CONNECTING:
            console.log('正在链接')
            break
          case RongIMLib.ConnectionStatus.DISCONNECTED:
            console.log('断开连接')
            break
          case RongIMLib.ConnectionStatus.KICKED_OFFLINE_BY_OTHER_CLIENT:
            console.log('其他设备登录')
            break
          case RongIMLib.ConnectionStatus.DOMAIN_INCORRECT:
            console.log('域名不正确')
            break
          case RongIMLib.ConnectionStatus.NETWORK_UNAVAILABLE:
            console.log('网络不可用')
            this.reconnectRy()
            break
        }
      }
    })
    // 消息监听器
    this.RongIMClient.setOnReceiveMessageListener({
      // 接收到的消息
      onReceived: (message) => {
        console.log('onReceived', message)
        if (message.content && message.content.content) {
          const content = JSON.parse(RongIMLib.RongIMEmoji.symbolToEmoji(message.content.content))
          this.onMsgCallback(content)
        }
      }
    })
    // 连接融云服务器
    this.RongIMClient.connect(token, {
      onSuccess: (userId) => {
        this.joinRoom(this.liveId)
      },
      onTokenIncorrect: function () {
        console.log('token无效')
      },
      onError: (errorCode) => {
        console.error('errorCode', errorCode)
        let info = ''
        switch (errorCode) {
          case this.RongIMClient.ErrorCode.TIMEOUT:
            info = '超时'
            this.reconnectRy()
            break
          case this.RongIMClient.ConnectionState.UNACCEPTABLE_PAROTOCOL_VERSION:
            info = '不可接受的协议版本'
            break
          case this.RongIMClient.ConnectionState.IDENTIFIER_REJECTED:
            info = 'appKey不正确'
            break
          case this.RongIMClient.ConnectionState.SERVER_UNAVAILABLE:
            info = '服务器不可用'
            break
          default:
            info = errorCode
            break
        }
        console.log('连接失败, 失败原因: ', info)
      }
    })
  }
  reconnectRy() {
    const callback = {
      onSuccess: (userId) => {
        this.joinRoom(this.liveId)
      },
      onTokenIncorrect: function () {
        console.log('token无效')
      },
      onError: function (errorCode) {
        console.log(errorCode)
      }
    }
    const config = {
      auto: true,
      rate: [100, 300, 500, 1000, 1500, 2000, 2000, 2000, 2000, 2000, 2000]
    }
    this.RongIMClient.reconnect(callback, config)
  }
  joinRoom(liveId) {
    console.log('liveId', liveId)
    this.RongIMClient.getInstance().joinChatRoom(liveId, -1, {
        onSuccess: () => {
            console.log('加入聊天室成功:' + liveId)
            const data = {
                roomId: this.liveId,
                joinType: getUrlQuery('share') ? 2 : 1 // 1：进入直播间 2：分享进入直播间
            }
            api.join_chat_room(data).then(res => console.log('joinroom', res))
        },
        onError(e) {
            console.error('加入聊天室失败', e)
        }
    })
}
  // h5暂时没有发送跑屏的功能（此功能需要userInfo）
  sendText({ roomInfo, eventName, extraData, params, callback }) {
    const conversationType = RongIMLib.ConversationType.CHATROOM
    
    if( currentUserInfo === null && vm ){
      currentUserInfo = vm.$storage.get('user_info') || null;
    }
    const { id, headImg, userName, weixinNickName, level } = currentUserInfo || {}
    const sendTime = new Date().getTime()
    // socket体默认字段

    let defaultText = {
      content: JSON.stringify({
        eventName,
        roomInfo,
        userInfo: {
          uid: id,
          headImg,
          userName: userName || weixinNickName,
          level: (level || {}).description || ''
        },
        msgCreateTime: sendTime,
        extraData: { ...extraData, ...params } || {}
      })
    }
    const sendDataMsg = new RongIMLib.TextMessage(defaultText)

    this.RongIMClient.getInstance().sendMessage(
      conversationType,
      roomInfo.roomId,
      sendDataMsg,
      {
        onSuccess: async () => {
          callback && callback(JSON.parse(defaultText.content))
          console.log(
            'ongIMClient.getInstance().sendMessage,,,,,,,,,,,,,,,',
            JSON.parse(defaultText.content)
          )
        },
        onError: function (errorCode) {
          let info = ''
          switch (errorCode) {
            case RongIMLib.ErrorCode.TIMEOUT:
              info = '超时'
              break
            case RongIMLib.ErrorCode.UNKNOWN:
              info = '未知错误'
              break
            case RongIMLib.ErrorCode.REJECTED_BY_BLACKLIST:
              info = '在黑名单中，无法向对方发送消息'
              break
            case RongIMLib.ErrorCode.NOT_IN_DISCUSSION:
              info = '不在讨论组中'
              break
            case RongIMLib.ErrorCode.NOT_IN_GROUP:
              info = '不在群组中'
              break
            case RongIMLib.ErrorCode.NOT_IN_CHATROOM:
              info = '不在聊天室中'
              break
          }
          console.log('发送失败: ' + info + errorCode)
        }
      }
    )
  }

  disconnectRy() {
    try {
      this.RongIMClient.getInstance().disconnect()
      // eslint-disable-next-line no-empty
    } catch (e) { }
  }
}

// 直接初始化
RongIMLib.RongIMEmoji.init();
